import { lazy } from 'react'

import { createFileRoute } from '@tanstack/react-router'

const UnauthorizedContent = lazy(
	() => import('@/features/app-shell/unauthorized-content'),
)

export const Route = createFileRoute('/_dashboard/unauthorized/')({
	component: UnauthorizedRoute,
	head: () => ({
		meta: [
			{
				title: 'Unauthorized | BitLyft AIR®',
			},
		],
	}),
})

function UnauthorizedRoute() {
	return (
		<div className="flex w-full flex-col items-center justify-center p-6">
			<UnauthorizedContent className="w-full" />
		</div>
	)
}
